export default __webpack_public_path__ + "00606b05dc8ac1c59c4e69556aa3bacb.svg";